var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-msg",style:(_vm.widthMsg && { width: _vm.widthMsg }),attrs:{"role":"tooltip"}},[(_vm.pointer)?_c('div',{staticClass:"tooltip-pointer"}):_vm._e(),_c('div',{staticClass:"body-text-1"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }